import * as React from "react";

import PodiumImg from "../../assets/robocup2026/web/podium.jpg";
import TrophyImg from "../../assets/robocup2026/web/trophy.jpg";
import KaraokeDevImg from "../../assets/robocupjo2025/karaoke_dev.png";
import MarladonaImg from "../../assets/marladona.png";

function Achievements() {
  return (
    <section className="trps-section trps-dark" id="Results">
      <div className="trps-wrap--wide">
        <h2 className="trps-h">実績</h2>
        <p className="trps-sub">
          2026シーズンは、国内の JapanOpen で3位に入り、研究成果が人工知能学会賞を受賞。
          その後の世界大会 RoboCup 2026 Incheon の SSL Division B では優勝することができました。
        </p>

        {/* World championship — two-photo collage */}
        <div className="trps-champ">
          <div className="trps-champ__collage">
            <figure className="trps-champ__photo trps-champ__photo--podium">
              <img src={PodiumImg} alt="RoboCup 2026 Incheon 表彰台のTRAPSメンバー" />
            </figure>
            <figure className="trps-champ__photo trps-champ__photo--trophy">
              <img src={TrophyImg} alt="RoboCup 2026 Incheon の優勝トロフィー" />
            </figure>
            <div className="trps-champ__cap">
              <p className="trps-champ__tag">RoboCup 2026 Incheon</p>
              <h3 className="trps-champ__rank">SSL Div. B 世界大会優勝</h3>
            </div>
          </div>
        </div>

        {/* other results */}
        <div className="trps-ach2">
          <article className="trps-ach trps-ach--japanopen">
            <div className="trps-ach__media">
              <img src={KaraokeDevImg} alt="JapanOpenに向けてロボットを開発するTRAPSメンバー" />
            </div>
            <div className="trps-ach__body">
              <p className="trps-ach__tag">RoboCup JapanOpen 2026</p>
              <h4 className="trps-ach__rank">SSL 国内大会 3位</h4>
            </div>
          </article>
          <article className="trps-ach trps-ach--award">
            <div className="trps-ach__media">
              <img src={MarladonaImg} alt="RoboCup SSL向けマルチエージェント強化学習環境" />
            </div>
            <div className="trps-ach__body">
              <p className="trps-ach__tag">RoboCup JapanOpen 2026</p>
              <h4 className="trps-ach__rank">人工知能学会賞</h4>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}

export default Achievements;
